import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 25, restDelta: 0.001 });
  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 z-[80] h-[2px] origin-left"
      style={{
        scaleX,
        background: "linear-gradient(90deg,#4A6CF7,#8A2BE2,#D4AF37)",
      }}
    />
  );
};

export default ScrollProgress;
